import { ComboDatePicker } from "components/ComboDatePicker";
import normalizeText from "normalize-text";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const ComboDate = ({ name, rules, onChangeFn = null, ...props }) => {
  const { control } = useFormContext();
  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ onChange, value }) => {
          return (
            <ComboDatePicker
              id={name}
              name={name}
              date={value}
              placeholder={["Año", "Mes", "Día"]}
              order='ymd'
              onChange={(_picker, date) => {
                if (
                  "invalid date" !== normalizeText(String(date)).toLowerCase() &&
                  "fecha invalida" !== normalizeText(String(date)).toLowerCase() &&
                  date !== null &&
                  date !== "" &&
                  date !== undefined
                ) {
                  onChange(date);
                  onChangeFn && onChangeFn(date);
                } else {
                  onChange(null);
                }
              }}
              attrsDate={{ disabled: props?.disabled || props?.loading }}
              attrsMonth={{ disabled: props?.disabled || props?.loading }}
              attrsYear={{ disabled: props?.disabled || props?.loading }}
              {...props}
            />
          );
        }}
      />
    </React.Fragment>
  );
};

export default ComboDate;
